import SvgIcon, { SvgIconProps } from "./SvgIcon";

const CupIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7216 5.44163C21.6796 5.06263 21.3586 4.77463 20.9766 4.77463H18.5136C18.5476 4.21563 18.5506 3.84263 18.5506 3.76562C18.5506 3.48862 18.3266 3.26562 18.0506 3.26562H5.94964C5.81664 3.26562 5.68964 3.31763 5.59664 3.41162C5.50264 3.50562 5.44964 3.63262 5.44964 3.76562C5.44964 3.84263 5.45264 4.21563 5.48764 4.77463H3.02364C2.64164 4.77463 2.32064 5.06263 2.27864 5.44163C2.25864 5.61563 1.83764 9.72162 4.99064 11.7976C5.11764 11.8806 5.26064 11.9206 5.40264 11.9206C5.64564 11.9206 5.88564 11.8026 6.02964 11.5836C6.25664 11.2376 6.16064 10.7726 5.81564 10.5446C4.08964 9.40862 3.78864 7.33764 3.75564 6.27464H5.62764C6.01664 9.40364 7.26464 14.3896 11.2466 14.9526V16.7086H8.90464C8.68664 16.7086 8.49464 16.8486 8.42864 17.0556L7.73164 19.2316H6.39964C5.98564 19.2316 5.64964 19.5666 5.64964 19.9816C5.64964 20.3956 5.98564 20.7316 6.39964 20.7316H17.7446C18.1586 20.7316 18.4946 20.3956 18.4946 19.9816C18.4946 19.5666 18.1586 19.2316 17.7446 19.2316H16.4126L15.7166 17.0556C15.6496 16.8486 15.4576 16.7086 15.2406 16.7086H12.7466V14.9546C16.7396 14.3996 17.9866 9.40763 18.3736 6.27464H20.2446C20.2106 7.33764 19.9106 9.40862 18.1846 10.5446C17.8396 10.7726 17.7436 11.2376 17.9716 11.5836C18.1156 11.8026 18.3546 11.9206 18.5976 11.9206C18.7396 11.9206 18.8826 11.8806 19.0106 11.7976C22.1626 9.72162 21.7416 5.61563 21.7216 5.44163Z"
          fill="currentColor"
        />
      ) : (
        <>
          <path
            d="M11.9964 14.6373V17.3345M8.01593 20.1071L8.90333 17.334H15.2396L16.127 20.1071M17.7441 20.107H6.39867M18.0497 3.89062H5.94922C5.94922 3.89062 5.95603 14.6366 12.0024 14.6366C18.0497 14.6366 18.0497 3.89062 18.0497 3.89062Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M6.0541 5.65234H3.02315C3.02315 5.65234 2.59696 9.45101 5.40217 11.2978"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M17.9453 5.65234H20.9763C20.9763 5.65234 21.4024 9.45101 18.5972 11.2978"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default CupIcon;
